import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { EventPayrollTab } from "../../../../../components/Events/Event/Payroll";
import { getEventRequest } from "../../../../../store/Events/actions";
import { adminPermissionModules } from "../../../../../utils/Constants";
import { useAdminModulePermission } from "../../../../../utils/adminPortalHelpers";

const PayrollTab = ({ onNestedViewChange }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const event = useSelector((state) => state.events.event);
  const { canView, canAdd, canEdit } = useAdminModulePermission(
    adminPermissionModules.payroll,
  );

  const handleRefreshEvent = () => {
    if (id) {
      dispatch(getEventRequest(id));
    }
  };

  if (!canView) {
    return null;
  }

  return (
    <EventPayrollTab
      event={event}
      className="event-payroll-tab"
      canAdd={canAdd}
      canEdit={canEdit}
      portal="admin"
      onNestedViewChange={onNestedViewChange}
      onRefreshEvent={handleRefreshEvent}
    />
  );
};

PayrollTab.propTypes = {
  onNestedViewChange: PropTypes.func,
};

PayrollTab.defaultProps = {
  onNestedViewChange: undefined,
};

export default PayrollTab;
